<template>
  <div>
    <!-- Intro -->
    <div class="has-background-black py-xxl">
      <div class="section">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-three-quarters">
              <div class="columns">
                <div class="column">
                  <div class="mb-lg">
                    <Logo color="white" />
                  </div>
                  <div class="mb-lg has-text-white">
                    <p class="is-uppercase has-text-weight-bold mb-sm" style="color:#177F87">fabric Dropship Platform</p>
                    <p class="is-size-3 has-text-weight-bold mb-md" style="line-height: 1.2;">Connect Shopify & scale your dropship fulfillment</p>
                  </div>
                </div>
                <div class="column">
                  <img src="https://res.cloudinary.com/revcascade/image/upload/c_scale,w_1400/c_crop,w_1000/v1681773948/static/shopify_assets/marketplace-hero.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section" style="margin-top:-4rem">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-three-quarters">
            <div class="has-background-white rounded-lg pa-xl">
              <!-- If user is not logged in -->
              <div v-if="showUserContext">
                <UserContext />
              </div>
              <!-- If user is not resolved -->
              <div v-else-if="auth.authenticating">
                <loading message="Signing in..." />
              </div>
              <!-- If user has one retailer -->
              <div v-else-if="auth.retailers && auth.retailers.length === 1">
                <b-button type="is-primary" size="is-medium" @click="goToDashboard">Continue to App</b-button>
              </div>
              <!-- If user more than one retailer -->
              <div v-else-if="auth.retailers && auth.retailers.length > 1">
                <b-button type="is-primary" size="is-medium" @click="selectContext">Continue to App</b-button>
              </div>
              <!-- If user has one supplier -->
              <div v-else-if="auth.suppliers && auth.suppliers.length === 1">
                <p class="is-size-5 has-text-success mb-lg">Shopify Connection Successful</p>
                <b-button type="is-primary" size="is-medium" @click="goToDashboard">Continue to App</b-button>
              </div>
              <!-- If user has more than one supplier -->
              <div v-else-if="auth.suppliers && auth.suppliers.length > 1">
                <p class="is-size-5 has-text-success mb-lg">Shopify Connection Successful</p>
                <b-button type="is-primary" size="is-medium" @click="selectContext">Continue to App</b-button>
              </div>
              <!-- General Error -->
              <div v-else>
                <p class="is-size-5">Installation Error</p>
                <p class="mb-md">It seems there was an error installing the Shopify app.</p>
                <p>Please contact our support team at</p>
                <p><a href="mailto:support@fabric.inc" class="has-text-info has-text-weight-bold">support@fabric.inc</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from '@/components/Logos/Logo'
import UserContext from '../components/ShopifyLink/UserContext'

export default {
  components: {
    Logo,
    UserContext
  },
  computed: {
    ...mapGetters(['api', 'app', 'auth'])
  },
  data () {
    return {
      token: null,
      showUserContext: false
    }
  },
  methods: {
    goToDashboard () {
      this.$router.push({ name: 'orders.dashboard' })
    },
    selectContext () {
      this.$router.push({ name: 'context.external' })
    }
  },
  mounted () {
    // existing flow where platform account already exists
    if (this.auth.user === null && 't' in this.$route.query) {
      this.token = this.$route.query.t
      this.$router.replace(this.$route.path)
      this.$store.dispatch('authenticate', { access_token: this.token }).then(() => {})
    } else {
      // authenticate guest users
      // authenticated users select account
      // create platform account
      // add condition to check for query params
      this.showUserContext = true
    }
  }
}

</script>
